import React from 'react'
import Utils from 'Utils'
import CloseIcon from '@material-ui/icons/Close';
import SnackBar from 'components/SnackBar'
import axios from 'axios'
import Matrix from 'scripts/Matrix'
import ModalAlert from '../ModalAlert'
import { Redirect } from 'react-router-dom'

class ConsultItemPatient extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      consult: props.consult,
      clientData: props.clientData,
      redirect: false,
      consultRequest: {}
    }
  }

  handleOnClick = () => {
    const { consult } = this.state

    if (consult.status === 'rejected') this.props.onRowClick('علت رد شدن', consult.rejectReason)
    if (consult.status !== 'initiated') return

    axios.get(Utils.urls.consultRequsetWaitingForPayment(this.state.consult.id), {
      headers: {
        'x-access-token': Matrix.getToken()
      }
    })
      .then(res => {
        let { consultRequest } = res.data
        if (!consultRequest.ConsultRequestPatientInfo) return;
        this.setState({
          redirect: true,
          consultRequest: res.data
        })
      })
      .catch(err => console.log(err))
  }


  apiDeleteConsult = async () => {
    let res = await axios.delete(Utils.urls.consultRequsetWaitingForPayment(this.state.consult.id), {
      headers: {
        'x-access-token': Matrix.getToken()
      }
    })
      .catch((e) => {
        console.log(e)
        let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
        this.SnackBar.openSnackbar(message)
      });

    if (!res) return
    const { success } = res.data
    this.props.onDeleteConsult(this.state.consult.id)
    if (!success) return this.SnackBar.openSnackbar('خطایی پیش آمده است')
  }


  render() {
    const { consult, consultRequest, redirect } = this.state

    if (redirect) {
      return <Redirect push={true} to={{ pathname: '/consult/new', state: { consultRequest } }} />
    }

    return (
      <div class='container' style={{ position: 'relative', background: '#f9f9f9' }} onClick={() => {
        if (consult.status === 'rejected') this.props.onRowClick('علت رد شدن', consult.rejectReason)
        if (consult.status === 'initiated') this.handleOnClick()
      }}>
        <SnackBar ref={el => { this.SnackBar = el }} />
        <div style={{ position: 'absolute', backgroundColor: '#0096de', minWidth: '5px', minHeight: '100%', right: '0px' }} />
        <div class="rooms-image">
          <img src="/images/consult.png" />
        </div>
        <div class="rooms-detail">
          <div class="rooms-name-date">
            <div class="rooms-name">
              {this.state.consult.doctor ?
                <p style={{ fontSize: '12px', padding: '0 4px', borderRadius: '4px', backgroundColor: '#0096de', color: '#fff', display: 'inline' }}>
                  {'درخواست مشاوره ' + (this.state.consult.doctor.fname || '') + ' ' + (this.state.consult.doctor.lname||'') }
                </p> :
                <p style={{ fontSize: '12px', padding: '0 4px', borderRadius: '4px', backgroundColor: '#0096de', color: '#fff', display: 'inline' }}>
                  {'درخواست مشاوره ' + ((this.state.consult.ConsultCategory && this.state.consult.ConsultCategory.name) || '')}
                </p>}
            </div>
            <div class="rooms-date">
              <span >
                {Utils.getJalaiData(this.state.consult.createdAt)}
              </span>
            </div>
          </div>
          <div class="rooms-last-content">
            <p className='rtl' style={{ flexGrow: 1, lineHeight: '20px', maxHeight: '20px', overflow: 'hidden' }}>
              {this.state.consult.question}
            </p>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }} onClick={this.handleOnClick}>
            <span class={`${consult.status === 'asked' && 'asked'} ${consult.status === 'initiated' && 'waiting'} ${consult.status === 'rejected' && 'reject'}`} style={{ fontSize: '12px', borderRadius: '4px', padding: '0 5px' }}>
              {consult.status === 'asked' && 'منتظر پاسخ'}
              {consult.status === 'initiated' && 'منتظر پرداخت'}
              {consult.status === 'rejected' && ' رد شده'}
            </span>
            <span style={{ fontSize: 10, margin: '0 5px' }}>{consult.status === 'rejected' && 'مبلغ به حساب شما بازگردانده شد '}</span>

            <span style={{ flex: 1 }}></span>
            {consult.status === 'initiated' &&
              <span className="delete-consult" onClick={e => {
                e.stopPropagation()
                this.props.openModal({ id: this.state.consult.id })
              }}>
                <span>حذف</span>
                <CloseIcon style={{ fontSize: 12, marginRight: 5 }} />
              </span>
            }

          </div>
        </div>
      </div>
    )
  }
}
export default ConsultItemPatient